import {AxiosResponse} from 'axios'
import {FavoriteRequest, Favorite} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface GetFavorite<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const getFavorite: GetFavorite<FavoriteRequest, Favorite> = (
  http,
  params,
) => {
  const {ClientID, PersonID, PhotoID} = params

  const path = '/v1/photos/{photoid}/favorites/{personid}'
    .replace('{personid}', PersonID.toString())
    .replace('{photoid}', PhotoID.toString())

  return http.request<Favorite>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}`,
  })
}
